export default "__VITE_ASSET__KC46L3vZ__"